import React from 'react';

import PropTypes from 'prop-types';

import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, condition, redirectTo = '/' }) =>
  condition ? <>{children}</> : <Navigate to={redirectTo} />;

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  condition: PropTypes.bool,
  redirectTo: PropTypes.string,
};

export default ProtectedRoute;
